module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_suns@3x-5e75cbabbf1c16853a0f492b64ad4e6f.webp";